import { JSONataRunner } from "./component/JSONataRunner";
import { JSONataContext } from "./contexts/JSONataEditorContext";

export function NodeJSONata(props) {
    return (
        <div style={{ height: "100vh" }}>
            <JSONataContext>
                <JSONataRunner {...props}/>
            </JSONataContext>
        </div>)
}

